import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import CenterContent from '../Components/CenterContent/CenterContent'
import InstrumentsWrrapper from '../Components/InstrumentsWrrapper/InstrumentsWrrapper'
import StudentSelects from '../Components/StudentSelects/StudentSelects'
import { observer } from 'mobx-react-lite'
import { student } from '../store/student.ts'
import StudentSearchByName from './../Components/StudentSelects/StudentSearchByName'
import DemandEduc from '../Components/Modal/DemandEduc'
import http from '../Service/http'
import { notify } from '../Utils/notify'
import { toast } from 'react-toastify'

export const StudentContainer = observer(function () {
	const { t, i18n } = useTranslation()
	const [active, setActive] = useState(0)
	const [demandEduc, setEducModal] = useState({
		show: false,
		id_student: 0
	})
	const [docList, setDocList] = useState([])

	useEffect(() => {
		document.onclick = hideMenu
		getDocumentList()
	}, [])

	const getDocumentList = async () => {
		const res = await http.get('/docList')

		const data = [].concat(res.data.data).sort((a, b) => (a.sort > b.sort ? 1 : -1))
		setDocList(data)
		console.log('docList', res.data)
	}

	const postInsertDocStudent = async id_okno_document => {
		const res = await http.post('/insertDocStudent', {
			uid: student.student.id_student,
			fac: student.student.id_faculty,
			gid: student.student.id_group,
			doc: id_okno_document,
			year: student.student.id_a_year,
			district: 0
		})
		toast('Заявка отправлена на исполнение')
		if (res.data.result === 'Заявка отправлена на исполнение') {
			notify('Заявка отправлена на исполнение')
		}
	}

	function hideMenu() {
		const contextMenu = document.getElementById('contextMenu')
		if (contextMenu) {
			contextMenu.style.display = 'none'
		}
	}

	function rightClick(e) {
		const contextMenu = document.getElementById('contextMenu')
		if (contextMenu) {
			if (contextMenu.style.display == 'block') {
				hideMenu()
			} else {
				const menu = document.getElementById('contextMenu')
				menu.style.display = 'block'
				menu.style.left = e.pageX + 'px'
				menu.style.top = e.pageY + 'px'
			}
		}
	}

	function documentClick(id_okno_document) {
		console.log('documentClick')

		postInsertDocStudent(id_okno_document)
		console.log('documentClick', id_okno_document)
		console.log('student', student.student.id_student)
	}

	return (
		<CenterContent>
			<InstrumentsWrrapper
				leftHead={t('st:instrumentsHead.leftHead')}
				rightHead={t('st:instrumentsHead.rightHead')}
				leftChilds={<StudentSelects />}
				rightChilds={<StudentSearchByName />}
			/>
			<DemandEduc
				stud={demandEduc.id_student}
				isOpen={demandEduc.show}
				setIsOpen={() => {
					setEducModal({
						show: false,
						id_student: 0
					})
				}}
			/>
			<div id='contextMenu' className='context-menu' style={{ display: 'none' }}>
				<ul className='menu'>
					{docList?.length &&
						docList.map((doc, index) => (
							<li className='share' key={doc.id_okno_document} onClick={() => documentClick(doc.id_okno_document)}>
								<a>
									<i className='fa fa-copy' aria-hidden='true'></i> {doc.okno_document}
								</a>
							</li>
						))}
					{/* <li className="share">
            <a
              target="_blank"
              href={`/bt/api/r/o-l?gid=${student.student.id_group}&id=${student.student.id_student}&idp=${student.student.id_protocols}&lang=${i18n.language}`} rel="noreferrer"
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.byPass")}
            </a>
          </li>
          <li className="rename">
            <a
              target="_blank"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setEducModal({
                  show: true,
                  id_student: student.student.id_student,
                });
              }}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.payEduc")}
            </a>
          </li>
          <li className="copy">
            <a
              target="_blank"
              href={`/bt/api/r/s-g?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.demandEduc")}
            </a>
          </li>
          <li className="copy">
            <a
              target="_blank"
              href={`/bt/api/r/l-e?id=${student.student.id_student}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.educLeave")}
            </a>
          </li>
          <li className="paste">
            <a
              target="_blank"
              href={`/bt/api/r/t-t?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.trunscript")}
            </a>
          </li>
          <li className="trash">
            <a
              target="_blank"
              href={`/bt/api/academ?id=${student.student.id_student}&gid=${student.student.id_group}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.acadenDemand")}
            </a>
          </li>
          <li className="trash">
            <a
              target="_blank"
              href={`/bt/api/r/p-n?id=${student.student.id_student}&gid=${student.student.id_group}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.personInfo")}
            </a>
          </li>
          <li className="trash">
            <a
              target="_blank"
              href={`/bt/api/r/a-e?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.archive")}
            </a>
          </li>
          <li className="trash">
            <a
              target="_blank"
              href={`/bt/api/r/call?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.call")}
            </a>
          </li>
            <li className="trash">
            <a
              target="_blank"
              href={`/bt/api/embassies?id=${student.student.id_student}&gid=${student.student.id_group}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.embassies")}
            </a>
          </li>
          <li className="trash">
            <a
              target="_blank"
              href={`/bt/api/r/timely?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
            >
              <i className="fa fa-copy" aria-hidden="true"></i>
              {t("st:demand.timely")}
            </a>
          </li> */}
				</ul>
			</div>
			<div className='TableWrapper'>
				<table>
					<thead>
						<tr>
							<th style={{ width: '5%' }}>№</th>
							<th style={{ width: '65%', textAlign: 'left' }}>{t('st:table.fio')}</th>
							<th style={{ width: '30%' }}>{t('st:table.group')}</th>
						</tr>
					</thead>
					<tbody>
						{student.students.map((item, index) => {
							if (item.id_student == active) {
								return (
									<tr
										className='contextenu active_line'
										key={index}
										onClick={() => {
											student.newStudent(item)
										}}
										onContextMenu={e => {
											student.newStudent(item)
											e.preventDefault()
											rightClick(e, item)
										}}
									>
										<td>{index + 1}</td>
										<td style={{ textAlign: 'left' }}>{item.fio}</td>
										<td>{item.p20}</td>
									</tr>
								)
							}
							return (
								<tr
									className='contextenu'
									key={index}
									onClick={() => {
										setActive(item.id_student)
										student.newStudent(item)
									}}
									onContextMenu={e => {
										student.newStudent(item)
										e.preventDefault()
										rightClick(e, item)
										setActive(item.id_student)
									}}
								>
									<td>{index + 1}</td>
									<td style={{ textAlign: 'left' }}>{item.fio}</td>
									<td>{item.p20}</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</CenterContent>
	)
})
